"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "MiniCalendar", {
  enumerable: true,
  get: function get() {
    return _MiniCalendar.default;
  }
});
exports.default = void 0;
var _Calendar = _interopRequireDefault(require("./Calendar"));
var _MiniCalendar = _interopRequireDefault(require("./MiniCalendar"));
function cov_1iobkmeigd() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/index.js";
  var hash = "246d0c8fa60cc3ca40309e6cc4e75136d826c1f6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "246d0c8fa60cc3ca40309e6cc4e75136d826c1f6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1iobkmeigd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1iobkmeigd();
var _default = exports.default = _Calendar.default;